import { EAtomName } from "~/_enums/EAtomName";

/** @returns `${atomName}Atom should be hydrated first` */
export const getHydrationErrorMessage = (atomName: EAtomName) =>
  `${atomName}Atom should be hydrated first`;
